import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { useLocation } from 'react-router-dom';
import Header from './components/feature/Header';
import Footer from './components/feature/Footer';

function AppContent() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isDashboardPage = location.pathname.startsWith('/dashboard');

  return (
    <div className="flex flex-col min-h-screen">
      {!isHomePage && !isDashboardPage && <Header />}
      <main className={`flex-grow ${!isHomePage && !isDashboardPage ? 'pt-20' : ''}`}>
        <AppRoutes />
      </main>
      {!isDashboardPage && <Footer />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;